import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-expand-arrows-icon',
  templateUrl: './general-expand-arrows.component.html'
})
export class GeneralExpandArrowsComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
